export default __webpack_public_path__ + "static/media/info-icon.811641ea.svg";